export default "__VITE_ASSET__BsMJD_n___"